export const CREATE_PRICING_OFFER_MUTATION = gql`
    mutation CreatePricingOffer($input: CreatePricingOfferInput!) {
        createPricingOffer(input: $input) {
            id
            name
            type
        }
    }
`;

export const UPDATE_PRICING_OFFER_MUTATION = gql`
    mutation UpdatePricingOffer($input: UpdatePricingOfferInput!) {
        updatePricingOffer(input: $input) {
            id
            name
            type
            status
        }
    }
`;

export const UPDATE_PRICING_OFFER_PARTNERS_MUTATION = gql`
    mutation UpdatePricingOfferPartners($input: UpdatePricingOfferPartnersInput!) {
        updatePricingOfferPartners(input: $input) {
            id
            name
            type
            partners {
                business {
                    legalName
                }
            }
        }
    }
`;
